// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SocialMedia_Wrapper__3uk58","Title":"SocialMedia_Title__36aST","SocialMedias":"SocialMedia_SocialMedias__1cpgq"};